import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import DeleteIcon from '@mui/icons-material/Delete'
import VendorPicker from '../../components/vendorPicker'
import DropZone from '../../components/Dropzone'

import config from '../../config.json'
import { Context as NotificationsContext } from '../../contexts/Notifications'
import { Context as AppContext } from '../../contexts/App'
const failedDownloadSnack = "InventoryCapital-failedDownloadSnack"

function InventoryCapital (props){
	const app = React.useContext(AppContext)
	const { vendor } = app
	const { capital } = app.inventories
	const {createSnack, openSnack, deleteSnack} = React.useContext(NotificationsContext)
	React.useEffect(() => {
		createSnack(failedDownloadSnack, {message: "Falló la generación de liquidaciones"})
		return () => deleteSnack(failedDownloadSnack)
	}, [])

	const [disabled, setDisabled] = React.useState(false)
	const [amazonFiles, setAmazonFiles] = React.useState([])
	const [clear, setClear] = React.useState(false)
	
	React.useEffect(() => {
	  setClear(true)
	}, [vendor])
	
	React.useEffect(() => {
	  clear && setClear(false)
	}, [clear])
  
	
	const onError = () => {
		setDisabled(false)
		openSnack(failedDownloadSnack)
	}
	
	const downloadFile = (download) => {
		console.log("downloading file: ", config.api_url+download)
		window.open(config.api_url+download, "_blank")
		setDisabled(false)
		setClear(true)
	}

	const submitFile = e => {
		e.stopPropagation()
		setDisabled( true)
		const data = new FormData()
		data.append("inventories", amazonFiles[0])
		data.append("vendor", vendor)
		capital(data, downloadFile, onError)
	}

	const flag = amazonFiles.length > 0

	return (
		<Box style={{
			display: 'flex',
			justifyContent: "center",
			margin: 'auto',
			width: 400,
			flexWrap: 'wrap',
		}}>
			<Box style={{ width: '100%', float: 'left' }}>
				<h3>Subir reporte de pagos</h3> <br />
			</Box>


			<Paper sx={{ cursor: flag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '200px', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
				<VendorPicker/>
				<Box sx={{display:vendor==='amazon'?'block':'none'}}>
					<DropZone accept=".csv" setFiles={setAmazonFiles} clear={clear}/>
				</Box>
				<Button disabled={!flag || disabled} onClick={submitFile} variant="contained" color="primary">
					{disabled?<CircularProgress size={27}/>:'Generar capital en inventario'}
				</Button>
			</Paper>
		</Box>
	)

}

export default InventoryCapital